// import React, { useState } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css"; // Important to import CSS

// function Leads() {
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     businessName: "",
//     businessProfession: "",
//     visitChapter: false,
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await fetch("https://v2vbn.org//leads.php", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       if (response.ok) {
//         toast.success("Your information has been submitted!");
//         setFormData({
//           name: "",
//           phone: "",
//           email: "",
//           businessName: "",
//           businessProfession: "",
//           visitChapter: false,
//         });
//       } else {
//         toast.error("Failed to submit. Please try again!");
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       toast.error("Something went wrong. Please try again!");
//     }
//   };

//   return (
//     <div className="support-page">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <section className="support-header text-center py-10 bg-light">
//         <div className="container">
//           <h2 className="mb-3">Register Your Business with Us</h2>
//           <p className="lead">
//             Join our growing community of businesses! Fill out this form to connect with like-minded professionals and learn about visiting a chapter.
//           </p>
//         </div>
//       </section>

//       <section className="support-form-section py-5">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-lg-8">
//               <form className="bg-white p-4 shadow rounded" onSubmit={handleSubmit}>
//                 <div className="contact-form-wrapper row">
//                   {/* Name */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <input
//                         className="input-field"
//                         name="name"
//                         placeholder="Name"
//                         type="text"
//                         value={formData.name}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                   </div>

//                   {/* Phone */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <input
//                         className="input-field"
//                         name="phone"
//                         placeholder="Phone No"
//                         type="text"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                   </div>

//                   {/* Email */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <input
//                         className="input-field"
//                         name="email"
//                         placeholder="Email"
//                         type="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                   </div>

//                   {/* Business Name */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <input
//                         className="input-field"
//                         name="businessName"
//                         placeholder="Business Name"
//                         type="text"
//                         value={formData.businessName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                   </div>

//                   {/* Business Profession */}
//                   <div className="col-lg-12">
//                     <div className="form-group">
//                       <select
//                         className="input-field"
//                         name="businessProfession"
//                         value={formData.businessProfession}
//                         onChange={handleChange}
//                         style={{ fontSize: "16px" }}
//                         required
//                       >
//                         <option value="">Select Profession</option>
//                         <option value="Consulting">Consulting</option>
//                         <option value="Retail">Retail</option>
//                         <option value="Service">Service</option>
//                         <option value="Technology">Technology</option>
//                         <option value="Manufacturing">Manufacturing</option>
//                       </select>
//                     </div>
//                   </div>

//                   {/* Visit Chapter */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <label style={{ display: "flex", alignItems: "center" }}>
//                         <input
//                           type="checkbox"
//                           name="visitChapter"
//                           checked={formData.visitChapter}
//                           onChange={handleChange}
//                           style={{ marginRight: "10px" }}
//                         />
//                         I want to visit a chapter
//                       </label>
//                     </div>
//                   </div>

//                   {/* Submit Button */}
//                   <div className="col-lg-12">
//                     <div className="form-submit-group">
//                       <button className="tmp-btn btn-primary" type="submit">
//                         Submit Now
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Leads;

import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

function Leads() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    address: "",
    number: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://api.v2vbn.org:8443/api/v1/visitors",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success("Your information has been submitted!");
        setFormData({
          name: "",
          email: "",
          password: "",
          address: "",
          number: "",
        });
        navigate("/verify-visitor-email");
      } else {
        toast.error("Failed to submit. Please try again!");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong. Please try again!");
    }
  };

  return (
    <div className="support-page">
      <ToastContainer position="top-right" autoClose={3000} />

      <section className="support-header text-center py-10 bg-light">
        <div className="container">
          <h2 className="mb-3">Register Your Business with Us</h2>
          <p className="lead">
            Join our growing community! Fill out the form to get started.
          </p>
        </div>
      </section>

      <section className="support-form-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <form
                className="bg-white p-4 shadow rounded"
                onSubmit={handleSubmit}
              >
                <div className="contact-form-wrapper row">
                  {/* Name */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="name"
                        placeholder="Name"
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="email"
                        placeholder="Email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Password */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="password"
                        placeholder="Password"
                        type="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  {/* Number */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="number"
                        placeholder="Mobile Number"
                        type="number"
                        value={formData.number}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  {/* Address */}
                  <div className="col-lg-12">
                    <div className="form-group">
                      <input
                        className="input-field"
                        name="address"
                        placeholder="Address"
                        type="text"
                        value={formData.address}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="col-lg-12">
                    <div className="form-submit-group">
                      <button className="tmp-btn btn-primary" type="submit">
                        Submit Now
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Leads;
